export type HighlightFillState = {
  doubted: boolean
  active: boolean
  dimmed: boolean
}

export function highlightFill({ doubted, active, dimmed }: HighlightFillState): string {
  if (dimmed) return 'bg-neutral-300/50'
  if (doubted) return active ? 'bg-red-400/70' : 'bg-red-300/45'
  return active ? 'bg-amber-400/70' : 'bg-amber-300/45'
}
